import { render, staticRenderFns } from "./storeDictionaryAdd.vue?vue&type=template&id=0d5d594b&scoped=true&"
import script from "./storeDictionaryAdd.vue?vue&type=script&lang=js&"
export * from "./storeDictionaryAdd.vue?vue&type=script&lang=js&"
import style0 from "./storeDictionaryAdd.vue?vue&type=style&index=0&id=0d5d594b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5d594b",
  null
  
)

component.options.__file = "storeDictionaryAdd.vue"
export default component.exports